const objeto1 = {
  titulo: `Objetos: conceptos básicos de propiedades`,
  problemas: [
    {
      codigo: 1,
      descripcion: `Existen variables que permiten almacenar un valor único (number, string, boolean)
<code>
  let altura = 1.92  // variable de tipo number
  let nombre = "Juan" // variable de tipo string
  let edad = 20 // variable de tipo number
  let existe = true //variable de tipo boolean
</code>
Para almacenar conjuntos de datos tenemos los Arrays y los Objetos. Veamos como se crean objetos en JavaScript:
<code>
  const persona1 = {
    nombre: "Juan",
    edad: 20,
    altura: 1.92
  }
</code>
Debemos encerrar entre llaves los atributos que queremos almacenar en el objeto. En el ejemplo anterior tenemos los atributos nombre, edad y altura.`,
      programa: `const persona1 = {
        nombre: "Juan",
        edad: 20,
        altura: 1.92
      }
console.log(persona1) // { nombre: "Juan", edad: 20, altura: 1.92 }`,
      solucion: "{ nombre: 'Juan', edad: 20, altura: 1.92 }"
    }, {
      codigo: 2,
      descripcion: `Para acceder al valor de una propiedad de un objeto debemos utilizar la notación de punto (.)
<code>
console.log(persona1.nombre) 
</code>`,
      programa: `const persona1 = {
        nombre: "Juan",
        edad: 20,
        altura: 1.92
      }
      
console.log(persona1.nombre)`,
      solucion: "'Juan'"
    }, {
      codigo: 3,
      descripcion: ``,
      programa: `const persona1 = {
        nombre: "Juan",
        edad: 20,
        altura: 1.92
      }
      
if (persona1.edad >= 18) {
  console.log("Es mayor de edad")
} else {
  console.log("Es menor de edad")
}`,
      solucion: "'Es mayor de edad'"
    }, {
      codigo: 4,
      descripcion: `Las propiedades de un objeto pueden ser modificadas asignando otro valor.`,
      programa: `const persona1 = {
        nombre: "Juan",
        edad: 20,
        altura: 1.92
      }
      
persona1.edad = 15
console.log(persona1)`,
      solucion: "{ nombre: 'Juan', edad: 15, altura: 1.92 }"
    }, {
      codigo: 5,
      descripcion: `Si tratamos de acceder a una propiedad que no existe en el objeto se obtiene el valor undefined.`,
      programa: `const persona1 = {
        nombre: "Juan",
        edad: 20,
        altura: 1.92
      }
      
console.log(persona1.estudios)`,
      solucion: "undefined"
    }, {
      codigo: 6,
      descripcion: `Podemos agregar propiedades a un objeto luego que se ha creado.`,
      programa: `const persona1 = {
        nombre: "Juan",
        edad: 20,
        altura: 1.92
      }
      
persona1.estudios = "Programador"
console.log(persona1)`,
      solucion: "{ nombre: 'Juan', edad: 20, altura: 1.92, estudios: 'Programador' }"
    }, {
      codigo: 7,
      descripcion: `Luego de crear un objeto, así como podemos agregar propiedades, tenemos la posibilidad de eliminar las mismas mediante el operador delete.`,
      programa: `const persona1 = {
        nombre: "Juan",
        edad: 20,
        altura: 1.92
      }
      
delete persona1.altura
console.log(persona1)`,
      solucion: "{ nombre: 'Juan', edad: 20}"
    }, {
      codigo: 8,
      descripcion: `La creación de un objeto vacío se hace disponiendo llaves de apertura y cerrado inmediatamente.`,
      programa: `const persona1 = {}
    
console.log(persona1)`,
      solucion: "{}"
    }
    , {
      codigo: 9,
      descripcion: ``,
      programa: `const producto1 = {}
producto1.nombre = "Papas"
producto1.precio = 65
producto1.stock = 10
console.log(producto1)`,
      solucion: "{ nombre: 'Papas', precio: 65, stock: 10 }"
    }, {
      codigo: 10,
      descripcion: ``,
      programa: `const producto1 = {
        codigo: 1,
        nombre: "Papas",
        precio: 65
      }
const producto2 = {
        codigo: 2,
        nombre: "Tomate",
        precio: 125
      }
if (producto1.precio > producto2.precio) {
  console.log(producto1.nombre)
} else {
  console.log(producto2.nombre)
}`,
      solucion: "'Tomate'"
    }, {
      codigo: 11,
      descripcion: `Algo muy importante es que cuando asignamos la referencia de un objeto a otro, esta referencia no hace una copia de sus atributos, sino que se hace referencia a la misma instancia de objeto.
Es decir que si asignamos un objeto a otra variable, sigue existiendo un solo objeto que tiene la referencia de 2 variables.`,
      programa: `const producto1 = {
        codigo: 1,
        nombre: "Papas",
        precio: 65
      }
  
const referencia = producto1
referencia.precio = 200
console.log(producto1)`,
      solucion: "{ codigo: 1, nombre: 'Papas', precio: 200 }"
    }, {
      codigo: 12,
      descripcion: `Si necesitamos definir un nombre de propiedad con espacios en blanco, debemos utilizar obligatoriamente comillas simples o dobles para encerrar la propiedad.`,
      programa: `const persona1 = {
        "apellido y nombre": "Perez Juan",
        edad: 30,
        altura: 1.70
      }
console.log(persona1)`,
      solucion: "{ 'apellido y nombre': 'Perez Juan', edad: 30, altura: 1.70 }"
    }, {
      codigo: 13,
      descripcion: `Para acceder luego a una propiedad que tiene espacios en blanco estoy obligado a utilizar una sintaxis de corchetes y como subíndice el nombre de la propiedad.  Se genera error si trato de utilizar el operador (.)`,
      programa: `const persona1 = {
        "apellido y nombre": "Perez Juan",
        edad: 30,
        altura: 1.70
      }
console.log(persona1["apellido y nombre"])`,
      solucion: "'Perez Juan'"
    }, {
      codigo: 14,
      descripcion: ``,
      programa: `const persona1 = {
        "apellido y nombre": "Perez Juan",
        edad: 30,
        altura: 1.70
      }
console.log(persona1.apellido y nombre)`,
      solucion: ""
    }, {
      codigo: 15,
      descripcion: `Podemos definir los valores de las propiedades de un objeto mediante variables previamente definidas.`,
      programa: `const nombre = 'Juan'
const apellido = 'Perez'
const edad = 30

const persona = {
  nombre: nombre,
  apellido: apellido,
  edad: edad
}

console.log(persona)`,
      solucion: "{nombre:'Juan', apellido:'Perez', edad:30}"
    }, {
      codigo: 16,
      descripcion: `Como vemos indicamos primero el nombre de la propiedad (apellido) y luego el nombre de la variable 'apellido', en el caso que sean iguales la propiedad y el nombre de la variable, se puede utilizar el concepto de propiedades abreviadas, obteniendo el mismo resultado que el ejemplo anterior.`,
      programa: `const nombre = 'Juan'
const apellido = 'Perez'
const edad = 30

const persona = {
  nombre,
  apellido,
  edad
}

console.log(persona)`,
      solucion: "{nombre:'Juan', apellido:'Perez', edad:30}"
    }
  ]
}

export default objeto1;